<script setup lang="ts">
import {
  PhxsgProductCardSlider,
  PhxsgProductCardSliderSlide,
} from '@sg/src/View/Components/Organisms/ProductCardSlider';
import ProductCard, { ProductCardProps } from '@maison/components/product/ProductCard.vue';

interface ProductSliderProps {
  products: ProductCardProps[];
}

defineProps<ProductSliderProps>();
</script>

<template>
  <PhxsgProductCardSlider v-cloak>
    <PhxsgProductCardSliderSlide v-for="product in products" :key="product.reference">
      <ProductCard v-bind="product" />
    </PhxsgProductCardSliderSlide>
  </PhxsgProductCardSlider>
</template>
